export const RETURN_POLICY = 'Return Policy';
export const EASY_RETURN_POLICY = 'Easy Return Policy';
const returnPolicyText = (returnAvailable: boolean) => {
    // if product is non returnable than text will be return policy
    // if  product is returnable but country code is not india then also text will be return policy
    // if product is returnable and internationalmode enable and country is india then text will be easy return olicy
    if (returnAvailable) {
      return EASY_RETURN_POLICY;
    }
    return RETURN_POLICY;
};

export default returnPolicyText;
